'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { type FC, useEffect } from 'react';

const HIDE_CMP_ON_PATHS = [
  '/datenschutz/',
  '/rechtliche-hinweise/',
  '/impressum/',
  '/hinweisgebersystem/',
  '/barrierefreiheit/',
  '/vertrag-kuendigen/',
  '/vertrag-widerrufen/',
];

export const ConsentScript: FC = () => {
  const path = usePathname();

  const hideCmp = HIDE_CMP_ON_PATHS.includes(path);

  useEffect(() => {
    (window as any).UC_UI_SUPPRESS_CMP_DISPLAY = hideCmp;

    if (!hideCmp && (window as any).UC_UI?.isInitialized?.() && (window as any).UC_UI?.isConsentRequired?.()) {
      (window as any).UC_UI.showFirstLayer();
    }
  }, [hideCmp]);

  return (
    <Script
      async
      data-settings-id={process.env.NEXT_PUBLIC_USERCENTRICS_ID}
      id="usercentrics-cmp"
      src="https://web.cmp.usercentrics.eu/ui/loader.js"
    />
  );
};
